import React from 'react';
import { BiWorld } from 'react-icons/bi';
import { FaRegCheckCircle } from 'react-icons/fa';
import ScrollReveal from "../../components/ScrollReveal";
import { useLanguage } from "../../contexts/LanguageContext";


type GreenCubeItemProps = {
    icon: React.ReactNode;
    title: string;
    description: string;
};

const GreenCubeItem: React.FC<GreenCubeItemProps> = ({ icon, title, description }) => {
    return (
        <div className="flex items-start mb-6">
            <div className="bg-[#83C441] p-4 rounded-full mr-5 flex items-center justify-center">
                {icon}
            </div>
            <div>
                <h2 className="text-lg font-bold text-white">{title}</h2>
                <p className="text-[#FFFFFF]/60 mt-2">
                    {description}
                </p>
            </div>
        </div>
    );
};

const GreenCube: React.FC = () => {
    const { t, tString } = useLanguage();
    return (
        <section id="greencube"
            className="w-screen px-16 py-16 bg-[#282A2A]"
        >
            <div className="scroll-mt-40 flex flex-col md:flex-row items-center justify-center gap-14 max-w-7xl mx-auto">
                <div className="w-full md:w-1/2 relative">
                    <ScrollReveal direction="left" delay={0.2} duration={0.8}>
                        <img
                            src="/images/logistics.png"
                            alt="Green Cube Logistics"
                            className="w-[550px] h-[300px] md:h-[500px] object-cover rounded-xl"
                        />
                        <img
                            src="/images/logo_gcl.png"
                            alt="Corner Icon"
                            className="absolute -top-5 -right-8 max-w-[140px] sm:max-w-sm "
                        />
                    </ScrollReveal>
                </div>

                <div className="w-full md:w-1/2 text-left">
                <ScrollReveal direction="up" delay={0.3} duration={0.8}>
                    <h1 className="text-3xl font-rockwell font-bold text-white mb-4">
                        {t('greencube.title')}
                    </h1>
                    </ScrollReveal>
                    <ScrollReveal direction="up" delay={0.4} duration={0.8}>
                    <p className="text-[#FFFFFF]/60 text-md text-light mb-8">
                        {t('greencube.description')}
                    </p>
                    </ScrollReveal>

                    <ScrollReveal direction="right" delay={0.5} duration={0.8}>
                    <GreenCubeItem
                        icon={<BiWorld className="text-white text-xl" />}
                        title={tString('greencube.features.globalSolutions.title')}
                        description={tString('greencube.features.globalSolutions.description')}

                    />
                    </ScrollReveal>
                    <ScrollReveal direction="right" delay={0.6} duration={0.8}>
                    <GreenCubeItem
                        icon={<FaRegCheckCircle className="text-white text-xl" />}
                        title={tString('greencube.features.specializedCargo.title')}
                        description={tString('greencube.features.specializedCargo.description')}

                    />
                    </ScrollReveal>
                    {/* Button */}
                    <ScrollReveal direction="right" delay={0.8} duration={0.8}>
                    <a href="https://www.greencubelog.com/" target="_blank" rel="noopener noreferrer" className="flex justify-center sm:justify-start">
                        <button className="bg-[#83C441] text-white mt-3 py-2 px-8 rounded-md hover:bg-lime-600 transition duration-200">
                            {t('greencube.visitWebsite')}
                        </button>
                    </a>
                    </ScrollReveal>

                </div>
            </div>
        </section>
    );
};

export default GreenCube;
